import { TYPES } from "../../types/types"

export const setLastDispatch = (code,type) => ({
    type: TYPES.setLastDispatch,
    payload: { code,type },
})

export const deleteLastDispatch = () => ({
    type: TYPES.deleteLastDispatch,
})